/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { ApiClient } from '@shared/api-client';
import { Location } from '@shared/models';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LocationService extends ApiClient {
  constructor(
    public httpClient: HttpClient,
  ) {
    super();
  }

  getLocations(): Observable<Location[]> {
    return this.httpClient.get<HttpResponse<Location[]>>(`${environment.backendServer}/api/locations?active=1`, {
      headers: this.LD_JSON_HEADERS
    }).pipe(
        map(response => {
          return response['hydra:member'];
        })
    );
  }
}
